import { Controller } from '@hotwired/stimulus';
import {
  eventListener,
  observer,
} from '@inked/utilities';

export class ScrollViewController extends Controller {
  static targets = [ 'backward', 'forward', 'item', 'view' ];
  static values = {
    behavior: {
      default: 'smooth',
      type: String,
    },
    loop: {
      default: false,
      type: Boolean,
    },
    step: {
      default: 1,
      type: Number,
    },
  };

  backward() {
    if (
      this.loopValue
      && this.scrollAtStart
    ) {
      this.viewTarget.scrollTo({ left: this.viewTarget.scrollWidth, behavior: this.behaviorValue });

      return;
    }

    this.viewTarget.scrollBy({ left: -this.scrollAmount(), behavior: this.behaviorValue });
  }

  connect() {
    this.stopScrollEvent = eventListener(this.viewTarget, 'scroll', () => this.onScroll());
    this.stopResizeObserver = observer(
      [ this.viewTarget, ...this.viewTarget.children ],
      'resize',
      () => this.onScroll(),
    );
  }

  disconnect() {
    this.stopScrollEvent();
    this.stopResizeObserver();
  }

  forward() {
    if (
      this.loopValue
      && this.scrollAtEnd
    ) {
      this.viewTarget.scrollTo({ left: 0, behavior: this.behaviorValue });

      return;
    }

    this.viewTarget.scrollBy({ left: this.scrollAmount(), behavior: this.behaviorValue });
  }

  onScroll() {
    if (this.loopValue) return;

    if (this.hasBackwardTarget) this.backwardTargets.forEach(backward => backward.disabled = this.scrollAtStart);
    if (this.hasForwardTarget) this.forwardTargets.forEach(forward => forward.disabled = this.scrollAtEnd);
  }

  scrollAmount() {
    if (this.hasItemTarget) {
      return this.itemTarget.offsetWidth * this.stepValue;
    }

    return this.viewTarget.offsetWidth * this.stepValue;
  }

  get scrollAtEnd() {
    return Math.abs(this.viewTarget.scrollWidth - this.viewTarget.clientWidth - this.viewTarget.scrollLeft) <= 1;
  }

  get scrollAtStart() {
    return this.viewTarget.scrollLeft === 0;
  }
}
